import { SpreadSheetImportProps } from 'types/spreadsheet';

export enum ImportState {
  Default = 'default',
  Loading = 'loading',
  ShowSheetModal = 'showSheetModal',
}

type ButtonCardProps = {
  onClick: () => void;
  description: string;
  buttonLabel: string;
  isLoading: boolean;
};

type SheetSelectModalContentProps = {
  handleLoadSheet: (sheetId: string) => void;
  onClose: () => void;
  SheetNames: string[];
};

export type { SpreadSheetImportProps, ButtonCardProps, SheetSelectModalContentProps };
